module.exports = __webpack_public_path__ + "img/serchscore.6d58a26e.png";